import { LoadingOutlined } from "@ant-design/icons";
import { Radio, Space, Spin } from "antd";
import { cn } from "../../../../utils/global.utils";

type Props = {
  currentQuestion: any;
  answers: Record<string, number>;
  submitted: boolean;
  handleAnswerChange: (questionId: string, value: number) => void;
  validationResult?: { isCorrect: boolean };
  isChecking?: boolean;
};

export default function QuizQuestions({
  currentQuestion,
  answers,
  submitted,
  handleAnswerChange,
  validationResult,
  isChecking,
}: Props) {
  return (
    <div className={cn("border border-theme-zinc-200 rounded-xl p-5")}>
      <div className="space-y-4">
        <div className="flex gap-3">
          <h4 className="text-theme-zinc-700 text-lg font-medium">
            {currentQuestion.question}
          </h4>
        </div>

        <Radio.Group
          value={answers[currentQuestion.id]}
          onChange={(e) =>
            handleAnswerChange(currentQuestion.id.toString(), e.target.value)
          }
          disabled={submitted || isChecking}
        >
          <Space direction="vertical" className="w-full">
            {currentQuestion.options.map((option: any, optIndex: number) => {
              const isSelected = answers[currentQuestion.id] === option.id;
              let optionClass =
                "w-full text-theme-slate-700 text-sm font-normal";
              let radioStyle: React.CSSProperties = {};

              // Loading State
              if (isSelected && isChecking) {
                optionClass = cn(optionClass, "text-theme-slate-700");
              }
              // Validation Result State
              else if (isSelected && validationResult) {
                if (validationResult.isCorrect) {
                  optionClass = cn(
                    optionClass,
                    "text-green-600 font-medium green-radio"
                  );
                  radioStyle = { color: "#16a34a" }; // Green-600
                } else {
                  optionClass = cn(
                    optionClass,
                    "text-theme-red-500 font-medium red-radio"
                  );
                  radioStyle = { color: "#ef4444" }; // Red-500
                }
              }

              return (
                <Radio
                  key={optIndex}
                  value={option.id}
                  className={optionClass}
                  style={radioStyle}
                >
                  <div className="flex items-center gap-2">
                    <span>{option.text}</span>
                    {isSelected && isChecking && (
                      <Spin
                        indicator={<LoadingOutlined spin />}
                        size="small"
                        className="ml-2"
                      />
                    )}
                  </div>
                </Radio>
              );
            })}
          </Space>
        </Radio.Group>
      </div>
    </div>
  );
}
